import { MatDialogConfig } from '@angular/material/dialog';
import { Client } from '../../client/classes/client';
import { Gruppe } from '../classes/gruppe';

export const GRUPPE_AUSWAHLEN_DIALOG_PANEL_CLASS = 'kiene-gruppe-auswahl-dialog';
export const GRUPPE_AUSWAHLEN_DIALOG_DESKTOP_PANEL_CLASS = 'kiene-gruppe-auswahl-dialog--desktop';

export function getGruppeAuswaehlenDialogShellConfig(mobile = false) {
    const { width, maxWidth, maxHeight, panelClass, autoFocus } = buildGruppeAuswaehlenDialogConfig(
        undefined,
        { mobile },
    );
    return { width, maxWidth, maxHeight, panelClass, autoFocus };
}

export function buildGruppeAuswaehlenDialogConfig(
    data?: GruppeAuswaehlenDialogInput,
    options?: { mobile?: boolean; disableClose?: boolean },
): MatDialogConfig<GruppeAuswaehlenDialogInput> {
    const mobile = options?.mobile ?? false;
    return {
        data,
        panelClass: mobile
            ? GRUPPE_AUSWAHLEN_DIALOG_PANEL_CLASS
            : [GRUPPE_AUSWAHLEN_DIALOG_PANEL_CLASS, GRUPPE_AUSWAHLEN_DIALOG_DESKTOP_PANEL_CLASS],
        width: mobile ? 'min(480px, calc(100vw - 32px))' : 'min(760px, calc(100vw - 48px))',
        maxWidth: mobile ? '96vw' : '92vw',
        maxHeight: '90vh',
        autoFocus: false,
        disableClose: options?.disableClose,
    };
}

export class GruppeAuswaehlenDialogInput {
    mehrereGruppen = false;
    kunde_id: number;
    except_gruppe_id: number;
    subtitle?: string;
}

export class GruppeAuswaehlenDialogResult {
    confirmed = false;
    gruppe: Gruppe;
    mehrereGruppen = false;
    ausstallenderBetrieb: Client;
}
